<cx-spinner class="overlay" *ngIf="isUpdating$ | async"></cx-spinner>
<cx-global-message aria-atomic="true" aria-live="assertive" style="width: auto" 
 ></cx-global-message>
<form (ngSubmit)="onSubmit()" class="custom-login-form d-flex flex-column" [formGroup]="form">
  <div class="login-header" login-header>
    <img width="200" height="80" alt="brands" src="./../../../../assets/images/brands.png"/>
  </div>
  <label class="mt-4 form-label">
    {{ "login.emailAddress.label" | cxTranslate }}
    <input required="true" type="text" class="form-control mt-2" formControlName="userId"
      placeholder="{{ 'login.emailAddress.placeholder' | cxTranslate }}" />
    <cx-form-errors [control]="form.get('userId')"></cx-form-errors>
  </label>

  <label class="mt-4 form-label">
    {{ "login.password.label" | cxTranslate }}
    <input required="true" type="password" class="form-control mt-2"
      placeholder="{{ 'login.password.placeholder' | cxTranslate }}" formControlName="password"
      [attr.aria-label]="'login.password.placeholder' | cxTranslate" cxPasswordVisibilitySwitch />
    <cx-form-errors [control]="form.get('password')"></cx-form-errors>
  </label>

  <div class="mt-2 d-flex form-link">
    <a [routerLink]="{ cxRoute: 'forgotPassword' } | cxUrl" class="btn-link">
      {{ "login.forgotPassword" | cxTranslate }}
    </a>
    <a [routerLink]="{ cxRoute: 'contactUs' } | cxUrl" class="btn-link">
      {{ "login.register" | cxTranslate }}
    </a>
  </div>

  <button type="submit" class="btn btn-block btn-primary login-btn" [disabled]="form.disabled">
    {{ "login.login" | cxTranslate }}
  </button>
</form>